<template>
  <div class="policy-page">
    <h1>Refund and Returns Policy</h1>
    <div class="policy-content">
      <p class="last-updated">Last updated: 6 May 2025</p>
      <p>Due to the unique and on-demand nature of the archive pieces we source, we do not accept returns unless the error was made on our end.</p>
      <section>
        <h2>We do not offer refunds in the following cases</h2>
        <ul>
          <li>The customer selected the wrong size, item, or condition</li>
          <li>The item received matches the photos and description shown at purchase</li>
          <li>The return request is based on a change of mind</li>
        </ul>
      </section>
      <section>
        <h2>Refunds will only be issued if</h2>
        <ul>
          <li>The item received does not match the photos or written description</li>
          <li>The error is verifiably our responsibility (wrong item, incorrect listing)</li>
        </ul>
      </section>
      <section>
        <h2>Procedure</h2>
        <ul>
          <li>Contact <a href="mailto:info@curatoreden.com">info@curatoreden.com</a> within 3 days of receiving your order</li>
          <li>Include your order number and clear photos of the item</li>
          <li>We will review the case and, if eligible, process the return and refund</li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RefundPolicy'
}
</script>

<style scoped>
.policy-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 24px;
  color: #333;
}

.last-updated {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1.5rem;
}

.policy-content {
  line-height: 1.6;
}

section {
  margin-bottom: 24px;
}

h2 {
  font-size: 1.2rem;
  color: #444;
  margin-bottom: 10px;
}

ul {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

li {
  margin-bottom: 0.5rem;
  color: #666;
  font-size: 1rem;
}

p {
  color: #666;
  margin-bottom: 15px;
}

a {
  color: #007bff;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .policy-page {
    padding: 20px;
  }
  h1 {
    font-size: 2rem;
    margin-bottom: 18px;
  }
  h2 {
    font-size: 1.05rem;
  }
}
</style> 